// extracted by mini-css-extract-plugin
export default {"videoBox":"videoTurning_videoBox__4ohPM","multipleWindowLayout":"videoTurning_multipleWindowLayout__73eui"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"videoBox\":\"videoTurning_videoBox__4ohPM\",\"multipleWindowLayout\":\"videoTurning_multipleWindowLayout__73eui\"}";
        // 1793842502193
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  